var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4109_19795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 39.9963C80 62.0841 62.0915 79.9926 40.0037 79.9926C17.9085 80 0 62.0841 0 39.9963C0 17.9085 17.9085 0 39.9963 0C62.0915 0 80 17.9085 80 39.9963Z",
    fill: "#27AE60",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 39.9966C75 59.3264 59.3318 75 40 75C20.6682 75 5 59.3333 5 39.9966C5 20.6667 20.6682 5 40 5C59.3249 5 75 20.6667 75 39.9966Z",
    fill: "#27AE60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1722 28.8467C57.3548 30.0292 57.3548 31.9734 56.1722 33.1559L36.5915 52.7367C35.4036 53.9245 33.4647 53.9245 32.2822 52.7367L31.382 51.8365C30.1995 50.6487 30.1995 48.7098 31.382 47.5219L50.9575 27.9465C52.1453 26.7639 54.0842 26.7639 55.272 27.9465L56.1722 28.8467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5967 52.7368C35.4142 53.9246 33.47 53.9246 32.2875 52.7368L22.6515 43.1009C21.469 41.9184 21.469 39.9741 22.6515 38.7916L23.5517 37.8967C24.7343 36.7089 26.6785 36.7089 27.861 37.8967L37.4969 47.5327C38.6794 48.7205 38.6794 50.6594 37.4969 51.8472L36.5967 52.7368Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4109_19795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.03669e872d9b77bd557a767c435054a4.svg";
export { ForwardRef as ReactComponent };